import { useMemo } from "react";

import { useNavigate } from "react-router-dom";

import { CommunicationSection } from "pages/home/components/CommunicationSection/index";
import { DateSection } from "pages/home/components/DateSection/index";
import { FixedNoticeCountSection } from "pages/home/components/FixedNoticeCountSection/index";
import { useHomeDashboardData } from "pages/home/hook/useHomeDashboardData";
import { useInquiries } from "pages/home/hook/useInquiries";
import { useRecentCommunications } from "pages/home/hook/useRecentCommunications";
import { useSuggests } from "pages/home/hook/useSuggests";
import { BaseContainer } from "shared/ui/layout";

function Home() {
  const navigate = useNavigate();
  const currentDate = useMemo(() => new Date(), []);
  const startDate = useMemo(
    () =>
      new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() - 30,
      ),
    [currentDate],
  );
  const endDate = useMemo(
    () =>
      new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + 1,
      ),
    [currentDate],
  );

  const { inquiries, suggests, notices } = useHomeDashboardData();
  const { filteredSuggests, suggestPer, suggestPer1 } = useSuggests({
    suggests,
    startDate,
    endDate,
  });
  const { filteredInquiries, inquiriesPer, inquiriesPer1 } = useInquiries({
    inquiries,
    startDate,
    endDate,
  });
  const { slicedData } = useRecentCommunications({ inquiries, suggests });

  const gotoNoticeDetail = () => {
    navigate("/notice");
  };

  return (
    <BaseContainer>
      <DateSection />
      <CommunicationSection
        filteredSuggests={filteredSuggests}
        filteredInquiries={filteredInquiries}
        suggestPer={suggestPer}
        suggestPer1={suggestPer1}
        inquiriesPer={inquiriesPer}
        inquiriesPer1={inquiriesPer1}
        slicedData={slicedData}
      />
      <FixedNoticeCountSection
        notices={notices}
        gotoNoticeDetail={gotoNoticeDetail}
      />
    </BaseContainer>
  );
}

export default Home;
